import plugin from './plugin';
import GlobalSnackbar_ from './GlobalSnackbar';

export const GlobalSnackbar = GlobalSnackbar_;
export default plugin;
